import { LitElement, html, css, unsafeCSS } from 'lit';
import { property } from 'lit/decorators.js';
import { RDPropsetContainer } from '../Container/PropContainer.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { icons } from '../../../Icons.js';

///@ts-ignore
import styles from './Icon.css?raw';
export class propIcon extends RDPropsetContainer {
  static styles: any = [
    super.styles,
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  @property({ type: String }) value = '';
  @property({ type: Boolean, reflect: true }) disabled = false;
  @property({ type: String, reflect: true }) position = 'left';
  @property({ type: String, reflect: true }) fill = 'currentColor';
  @property({ type: String, reflect: true }) stroke = 'currentColor';
  @property({ type: String, reflect: true }) color = 'currentColor';
  @property({ type: String, reflect: true }) fontSize = '16px';
  @property({ type: String, reflect: true }) height = '24px';
  @property({ type: String, reflect: true }) width = '24px';
  @property({ attribute: false }) callback = null;
  @property({ attribute: false }) onClick = null;

  firstUpdated() {
    super.firstUpdated();
  }

  _onClick(e) {
    if (this.onClick && typeof this.onClick === 'function') {
      this.onClick.bind(this)(this.value);
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(this.value);
    }
    this.dispatchEvent(new CustomEvent('prop-clicked', { detail: { value: this.value } }));
  }
  _renderIcon() {
    let allIcons = this.querySelectorAll('.prop-icon');
    allIcons.forEach((icon) => {
      icon.remove();
    });
    if (!this.value || this.value.trim() === '') {
      return html`${unsafeHTML(icons.noIcon)}`;
    }
    const icon = document.createElement('div');
    icon.classList.add('prop-icon', 'svg-Container');
    icon.setAttribute('slot', 'prop-icon');
    icon.style.fill = this.fill;
    icon.style.stroke = this.stroke;
    icon.style.color = this.color;
    icon.style.fontSize = this.fontSize || '16px';
    icon.style.height = this.height || '24px';
    icon.style.width = this.width || '24px';
    icon.style.display = 'flex';
    icon.style.alignItems = 'center';
    icon.style.justifyContent = 'center';

    icon.innerHTML = this.value || '';
    this.appendChild(icon);
    return '';
  }
  renderBody() {
    return html`<div class="rd-prop-icon-container ${this.position || 'left'}">
      <div class="rd-prop-icon-button focus-within ${this.disabled ? 'disabled' : ''}" @click="${(e) => this._onClick(e)}" tabindex="-1">
        <slot name="prop-icon"></slot>
        <span class="svg-Container"> ${this._renderIcon()} </span>
      </div>
    </div>`;
  }
}
if (!customElements.get('rd-prop-icon')) {
  customElements.define('rd-prop-icon', propIcon as any);
}
